// extracted by mini-css-extract-plugin
module.exports = {"app":"Layout_app__3x6O-"};